import { AxiosResponse, AxiosRequestConfig } from 'axios';
import client from 'api/client';

export const residenceStatus = {
    get(country: string, customConfig?: AxiosRequestConfig): Promise<AxiosResponse<string[]>> {
        return client.get<string[]>(`/residential_status/${country}`, customConfig);
    },
};
